import { render, staticRenderFns } from "./ReadingsResultsGeneral.vue?vue&type=template&id=1f167dad"
import script from "./ReadingsResultsGeneral.vue?vue&type=script&lang=js"
export * from "./ReadingsResultsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports